import { NavLink } from "react-router-dom";
import styles from "../styles/blogpost/RelatedPosts.module.css";
import { normalizeBlogSlug } from "../../helpers/pathUtils";
import blogsData from "../../constants/blogsData";
import type { BlogPost } from "../../types/blog";
import { paths } from "../../constants/paths";

type Props = { currentPost: BlogPost };

const RelatedPosts = ({ currentPost }: Props) => {
  // Find up to 3 posts in the same category, excluding the current post
  const typedBlogsData = blogsData as unknown as BlogPost[];
  const relatedPosts = typedBlogsData
    .filter(
      (post) => post.id !== currentPost.id)
    .slice(0, 3);

  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <section className={styles.relatedPosts}>
      <h3 className={styles.relatedTitle}>Related Articles</h3>
      <div className={styles.relatedGrid}>
        {relatedPosts.map((post: BlogPost) => {
          const normalizedSlug = normalizeBlogSlug(post.slug || post.id);
          const postUrl = `${paths.blog}${normalizedSlug}/`;

          return (
            <article key={post.id} className={styles.relatedPost}>
              <div className={styles.relatedImage}>
                <NavLink to={postUrl}>
                  {post?.featured_image ? (
                    <img
                      src={post?.featured_image}
                      alt={post?.title}
                      loading="lazy"
                      className={styles.image}
                    />
                  ) : (
                    <div className={styles.image} aria-hidden="true" />
                  )}
                </NavLink>
              </div>

              <div className={styles.relatedContent}>
                <span className={styles.relatedCategory}>{post.category}</span>
                <h3 className={styles.relatedPostTitle}>
                  <NavLink to={postUrl} className={styles.relatedLink}>
                    {post.title}
                  </NavLink>
                </h3>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default RelatedPosts;
